import React, { FC } from 'react';
import { FormGroup, FormLabel, Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import NumberInput from '../../../../../../components/library/inputs/number/NumberInput';

interface Props {
  label: string;
  value: number | undefined;
  onChange: (number?: number) => void;
  size?: number;
  maxValue?: number;
  minValue?: number;
}

const NumberSetting: FC<Props> = ({ label, value, onChange, size = 12, maxValue, minValue }: Props) => {
  return (
    <FormGroup className={'form-group'} as={Col} md={size}>
      <FormLabel>
        <FormattedMessage id={label} />
      </FormLabel>
      <NumberInput
        onChange={(event) => {
          if (!isNaN(parseInt(event.target.value))) {
            onChange(parseInt(event.target.value));
          } else {
            onChange(undefined);
          }
        }}
        value={value}
        maxValue={maxValue}
        minValue={minValue}
      />
    </FormGroup>
  );
};

export default NumberSetting;
